import { render, staticRenderFns } from "./ClientDashboardView.vue?vue&type=template&id=725a0234&"
import script from "./ClientDashboardView.vue?vue&type=script&lang=js&"
export * from "./ClientDashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports